module.exports = __webpack_public_path__ + "img/underline-orange.cddbddc8.svg";